import { useQuery } from "@tanstack/react-query";
import { getPayLaterEnabledByMerchantId } from "../actions/getPayLaterEnabledByMerchantId";

const QUERY_KEY = ["paypal", "pay-later-enabled"] as const;

export const usePayLaterEnabled = (merchantId: string | undefined) => {
  const query = useQuery({
    queryKey: [...QUERY_KEY, merchantId ?? ""],
    queryFn: () => getPayLaterEnabledByMerchantId(merchantId!),
    enabled: !!merchantId?.trim(),
  });
  const payLaterEnabled = query.data?.payLaterEnabled !== false;
  return { ...query, payLaterEnabled };
};
